import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ShopDetailSlider from './ShopDetailSlider';

function ShopDetail() {
    const [quantity, setQuantity] = useState(5); 
    const decreaseQuantity = () => {
        if (quantity > 1) { 
            setQuantity(quantity - 1);
        }
    };
    const increaseQuantity = () => {
        setQuantity(quantity + 1);
    };

  return (
    <div>
        
    <div className="breadcrumb-row">
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="d-flex justify-content-between align-items-center breadcrumb-item">
                        <div className="breadcrumb-title-heading">
                            <h1 className="title">Shop Details</h1>
                        </div>
                        <div className="breadcrumb-wrapper">
                            <span className="mr-1"><i className="ti ti-home"></i></span>
                            <Link title="Homepage" to="/">Home</Link>
                            <span className="ttm-bread-sep">&nbsp;/&nbsp;</span>
                            <span className="ttm-textcolor-skincolor">Shop Details</span>
                        </div>
                    </div>
                </div>
            </div>  
        </div>                    
    </div>
    {/* <!-- Section Start --> */}
    <section className="section pb-0">
        <div className="container-fluid">
            <div className="row">
                <div className="col-xl-8">
                    <div className="shop_details_box">
                        <div className="row">
                            <div className="col-lg-6">
                            <ShopDetailSlider/>
                            </div>
                            <div className="col-lg-6">
                                <div className="product_details product_block">
                                    <h2 className="product_title">Drill Machine </h2>
                                    <div className="ratings">
                                    <i className="fal fa-star active"></i>
                                    <i className="fal fa-star active"></i>
                                    <i className="fal fa-star active"></i>
                                    <i className="fal fa-star active"></i>
                                    <i className="fal fa-star"></i>
                                    </div>
                                    <div className="price">
                                    <span>$55.00</span>
                                    <span>$80.25</span>
                                    </div>
                                    <p className="text">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis
                                    ipsum suspendisse ultrices gravida.
                                    </p>
                                    <div className="product_action">
                                    <div className="quantity">
                                        <button className="btn qty-mins" type="button" onClick={decreaseQuantity}>
                                            <i className="fal fa-minus"></i>
                                        </button>
                                        <input
                                            type="number"
                                            name="#"
                                            value={quantity}
                                            autoComplete="off"
                                            readOnly
                                        />
                                        <button className="btn qty-add" type="button" onClick={increaseQuantity}>
                                            <i className="fal fa-plus"></i>
                                        </button>
                                    </div>
                                    <Link to="/cart" className="thm-btn btn-rounded thm-bg-color-one">
                                        Add To Cart
                                    </Link>
                                    </div>

                                    <div className="product_social">
                                    <button type="button" className="social_trigger">
                                        <i className="fas fa-share-alt"></i>
                                    </button>
                                    <ul className="social_media">
                                        <li>
                                        <Link to="#">
                                            <i className="fab fa-facebook-f"></i>
                                        </Link>
                                        </li>
                                        <li>
                                        <Link to="#">
                                        <i className="fa-brands fa-x-twitter"></i>
                                        </Link>
                                        </li>
                                        <li>
                                        <Link to="#">
                                            <i className="fab fa-linkedin-in"></i>
                                        </Link>
                                        </li>
                                        <li>
                                        <Link to="#">
                                            <i className="fab fa-pinterest-p"></i>
                                        </Link>
                                        </li>
                                    </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <h4>Ratings</h4>
                                <div className="ratings_block">
                                    <div className="total_rating">
                                        <div className="value">
                                            9.2
                                            <i className="fas fa-star"></i>
                                        </div>
                                        <p className="mb-0">7.5k Verified Buyers</p>
                                    </div>
                                    <div className="rating_bar">
                                        <ul>
                                            <li>
                                                <span className="rate">5 <i className="fas fa-star"></i></span>
                                                <div className="rate_bar">
                                                    <div data-valuenow="45" data-valuemin="0" data-valuemax="100"></div>
                                                </div>
                                                <div className="rate_value">4561</div>
                                            </li>
                                            <li>
                                                <span className="rate">4 <i className="fas fa-star"></i></span>
                                                <div className="rate_bar">
                                                    <div data-valuenow="84" data-valuemin="0" data-valuemax="100"></div>
                                                </div>
                                                <div className="rate_value">8413</div>
                                            </li>
                                            <li>
                                                <span className="rate">3 <i className="fas fa-star"></i></span>
                                                <div className="rate_bar">
                                                    <div data-valuenow="20" data-valuemin="0" data-valuemax="100"></div>
                                                </div>
                                                <div className="rate_value">2010</div>
                                            </li>
                                            <li>
                                                <span className="rate">2 <i className="fas fa-star"></i></span>
                                                <div className="rate_bar">
                                                    <div data-valuenow="10" data-valuemin="0" data-valuemax="100"></div>
                                                </div>
                                                <div className="rate_value">1010</div>
                                            </li>
                                            <li>
                                                <span className="rate">1 <i className="fas fa-star"></i></span>
                                                <div className="rate_bar">
                                                    <div data-valuenow="5" data-valuemin="0" data-valuemax="100"></div>
                                                </div>
                                                <div className="rate_value">561</div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- Customer Photos --> */}
                        <div className="row">
                            <div className="col-12">
                                <div className="customer_photos">
                                    <h4>Customer Photos (159)</h4>
                                    <div className="images">
                                        <img src="/tm/react/toolways/assets/images/product/photos/1.png" className="image-fit-contain" alt="img"/>
                                        <img src="/tm/react/toolways/assets/images/product/photos/2.png" className="image-fit-contain" alt="img"/>
                                        <img src="/tm/react/toolways/assets/images/product/photos/3.png" className="image-fit-contain" alt="img"/>
                                        <img src="/tm/react/toolways/assets/images/product/photos/4.png" className="image-fit-contain" alt="img"/>
                                        <img src="/tm/react/toolways/assets/images/product/photos/5.png" className="image-fit-contain" alt="img"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- Reviews --> */}
                        <div className="row">
                            <div className="col-12">
                                <h4>Customer Reviews (601)</h4>
                                <ul className="comments">
                                    <li className="comment">
                                        <span className="comment_rate">
                                            4 <i className="fas fa-star"></i>
                                        </span>
                                        <p className="comment_text">
                                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries
                                        </p>
                                        <div className="customer_photos">
                                            <div className="images">
                                                <img src="/tm/react/toolways/assets/images/product/photos/1.png" className="image-fit-contain" alt="img"/>
                                                <img src="/tm/react/toolways/assets/images/product/photos/2.png" className="image-fit-contain" alt="img"/>
                                                <img src="/tm/react/toolways/assets/images/product/photos/3.png" className="image-fit-contain" alt="img"/>
                                            </div>
                                        </div>
                                        <div className="comment_meta">
                                            <ul className="comment_author">
                                                <li>Jhon Deo</li>
                                                <li>11 March 2024</li>
                                            </ul>
                                            <ul className="comment_action">
                                                <li>
                                                    <button type="button">
                                                        <i className="fal fa-thumbs-up"></i>
                                                        5
                                                    </button>
                                                </li>
                                                <li>
                                                    <button type="button">
                                                        <i className="fal fa-thumbs-down"></i>
                                                        1
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                    <li className="comment">
                                        <span className="comment_rate">
                                            4 <i className="fas fa-star"></i>
                                        </span>
                                        <p className="comment_text">
                                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries
                                        </p>
                                        <div className="customer_photos">
                                            <div className="images">
                                                <img src="/tm/react/toolways/assets/images/product/photos/4.png" className="image-fit-contain" alt="img"/>
                                                <img src="/tm/react/toolways/assets/images/product/photos/5.png" className="image-fit-contain" alt="img"/>
                                            </div>
                                        </div>
                                        <div className="comment_meta">
                                            <ul className="comment_author">
                                                <li>Jhon Anderson</li>
                                                <li>11 March 2024</li>
                                            </ul>
                                            <ul className="comment_action">
                                                <li>
                                                    <button type="button">
                                                        <i className="fal fa-thumbs-up"></i>
                                                        5
                                                    </button>
                                                </li>
                                                <li>
                                                    <button type="button">
                                                        <i className="fal fa-thumbs-down"></i>
                                                        1
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <aside className="col-xl-4">
                    <div className="product_sidebar">
                        <div className="product_sidebar_wrap">
                            <div className="sidebar_widget">
                                <h5 className="widget_title">Product Details</h5>
                                <div className="product_info">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p>
                                    <h6>Specifications</h6>
                                    <ul>
                                        <li>
                                            <p className="mb-0">Category</p>
                                            <strong>Drill,Grinder </strong>
                                        </li>
                                        <li>
                                            <p className="mb-0">SKU</p>
                                            <strong>4657482</strong>
                                        </li>
                                        <li>
                                            <p className="mb-0">Tags</p>
                                            <strong>Drill Grinder,Hand,Tool</strong>
                                        </li>
                                        
                                        <li>
                                            <p className="mb-0">Seller</p>
                                            <strong>Contrary to popular Private Limited</strong>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="sidebar_widget">
                                <h5 className="widget_title">Similar Products</h5>
                                <ul className="related_products">
                                    <li>
                                        <div className="product_thumb">
                                            <Link to="/shop-details">
                                                <img src="/tm/react/toolways/assets/images/product/grid/1.png" className="image-fit-contain" alt="img"/>
                                            </Link>
                                        </div>
                                        <div className="product_caption">
                                            <h6 className="product_title mb-0"><Link to="/shop-details">Consecteutre Adipicing</Link></h6>
                                            <p className="mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing.</p>
                                            <p className="price">
                                                <span>$80.00</span>
                                                <span>$90.00</span>
                                            </p>
                                            <button type="button" className="thm-btn btn-rounded thm-bg-color-three small_btn">Add To Cart</button>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="product_thumb">
                                            <Link to="/shop-details">
                                                <img src="/tm/react/toolways/assets/images/product/grid/2.png" className="image-fit-contain" alt="img"/>
                                            </Link>
                                        </div>
                                        <div className="product_caption">
                                            <h6 className="product_title mb-0"><Link to="/shop-details">Nam Consectetur quam</Link></h6>
                                            <p className="mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing.</p>
                                            <p className="price">
                                                <span>$80.00</span>
                                                <span>$90.00</span>
                                            </p>
                                            <button type="button" className="thm-btn btn-rounded thm-bg-color-three small_btn">Add To Cart</button>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="product_thumb">
                                            <Link to="/shop-details">
                                                <img src="/tm/react/toolways/assets/images/product/grid/3.png" className="image-fit-contain" alt="img"/>
                                            </Link>
                                        </div>
                                        <div className="product_caption">
                                            <h6 className="product_title mb-0"><Link to="/shop-details">Mormi Accumsan Tellu</Link></h6>
                                            <p className="mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing.</p>
                                            <p className="price">
                                                <span>$80.00</span>
                                                <span>$90.00</span>
                                            </p>
                                            <button type="button" className="thm-btn btn-rounded thm-bg-color-three small_btn">Add To Cart</button>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </aside>
            </div>
        </div>
    </section>
    </div>
  )
}

export default ShopDetail